import { Component, OnInit, ViewChild } from '@angular/core';

import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { CollanaService } from './../../../services/collana.service';
import { AppComponent } from './../../../app.component';

import { Collana } from '../../../models/Collana';

@Component({
  selector: 'app-collana-form',
  templateUrl: './collana-form.component.html',
  styleUrls: ['./collana-form.component.css'],
  providers: [CollanaService]
})
export class CollanaFormComponent implements OnInit {
  wmodel: Collana = new Collana();
  dirty: boolean;
  loading: boolean;
  codiceChecking: boolean;
  updateMode: boolean;
  @ViewChild('f') form: FormGroup;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private collanaService: CollanaService,
    public parent: AppComponent) { }

  getTitle(): string {
    return "collana";
  }

  onCodiceBlur() {
    this.codiceChecking = true;
    setTimeout(() => {
      this.collanaService.getCollana(this.wmodel.codice).subscribe((res) => {
        if (res.success && res.collana) {
          this.parent.operSnackBar(true, 'collana esistente');
          this.router.navigate(['/collana/' + this.wmodel.codice]);
        }
        this.codiceChecking = false;
      })
    }, 1000);
  }

  persist() {
    let that = this;
    that.loading = true;
    that.parent.addToast('', 'salvataggio in corso...', ((wid) => {
      setTimeout(function() {
        that.collanaService.persist(that.wmodel).subscribe((res) => {
          console.log(res)
          if (res.success && res.result) {
            this.wmodel = new Collana(res.result.value);
          }
          that.parent.clearToast(wid);
          that.loading = false;
          that.parent.operSnackBar(res.success, res.success ? 'salvataggio completato' : res.err)
        })
      }, 2000);
    }))
  }

  onNotifyCollana(o: Collana): void {
    console.log('onNotify', o)
  }

  ngOnInit() {
    let codice = this.route.snapshot.paramMap.get('codice');
    console.log(codice);
    if (codice) {
      this.updateMode = true;
      this.collanaService.getCollana(codice).subscribe(result => {
        console.log(result);
        this.wmodel = new Collana(result.collana);
        console.log(this.wmodel);
      })
    } else {
      this.wmodel = new Collana();
    }
  }

  addNewCollana() {
    this.router.navigate(['/collana']);
  }

  go2search() {
    this.router.navigate(['/collana/search']);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/collana/collana-form/collana-form.component.ts